import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import notifications from './notifications'
import poolIndex from './poolIndex'
import poolAddEdit from './poolAddEdit'
import poolDetails from './poolDetails'
import restaurantDetails from './restaurantDetails'
import shifts from './shifts'
import restaurantsEdit from './restaurantsEdit'
import restaurantSearch from './restaurantSearch'
import deliveryHours from './deliveryHours'
import system from './system'
import schedules from './schedules'
import restaurantPoolSchedule from './restaurantPoolSchedule'
import modal from './modal'
import rdsPartners from './rdsPartners'
import { reducer as oidcReducer } from 'redux-oidc'

export default combineReducers({
  router: routerReducer,
  oidc: oidcReducer,
  poolIndex,
  poolAddEdit,
  poolDetails,
  shifts,
  schedules,
  deliveryHours,
  restaurantsEdit,
  restaurantSearch,
  restaurantDetails,
  notifications,
  system,
  modal,
  rdsPartners,
  restaurantPoolSchedule
})



// WEBPACK FOOTER //
// ./src/reducers/index.js